import { render, staticRenderFns } from "./WarehouseMemo.vue?vue&type=template&id=8a2ce5a0"
import script from "./WarehouseMemo.vue?vue&type=script&lang=js"
export * from "./WarehouseMemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports